module.exports = __webpack_public_path__ + "img/chinesecompany17.0a7e54c8.png";